<template>
  <!--新建/审批内容-->
  <div id="editMainDatePic">
    <div class="allSearch">
      <div class="newSearch d_flex">
        <div style="width: auto">
          <!-- <p class="font16">{{previewContentId === 0 ? '新建内容':'编辑内容'}}</p> -->
          <p class="font16 bottom">新建推送</p>
        </div>
        <div style="width: auto">
          <button class="cancelButtonTwo" @click="allReturn">返回</button>
        </div>
      </div>
    </div>
    <div class="allTablePlace">
      <!-- <div class="switchNav"><span @click="changeType(true)" :class="CNmode ? 'onSwitchSpan' : ''">中文</span><span @click="changeType(false)" :class="CNmode ? '' : 'onSwitchSpan'">英文</span></div> -->

      <div class="input">
        <div class="showUEplace" :style="{'display': CNmode ? 'block' : 'none'}">
          <div id="ueditor" type="text/plain"></div>
        </div>
        <div class="showUEplace" :style="{'display': CNmode ? 'none' : 'block'}">
          <nav class="m_l_10 m_b_5"><i class="VioletDot"></i><abbr class="font16">content</abbr></nav>
          <div id="ueditor2" type="text/plain"></div>
        </div>
        <div class="m_t_10 t_r">
          <!-- <button v-if="previewContentId !== 0" @click="coverShow = true" class="redButtonTwo"><i class="icon iconfont iconyanjing"></i><span class="m_l_5 m_r_5">预览</span><i class="icon iconfont iconxiala"></i></button> -->
          <button class="redButtonTwo"  @click="saveDraft">发布</button>
          <button class="redButtonTwo" @click="SendList()" v-if="this.previewContentId !== 0 && fromType !== 'MaterialLibrary'">发布测试消息</button>
          <!-- <button class="redButtonTwo"  @click="preview">预览</button> -->
          <!-- <button  v-if="fromType === 'MaterialLibrary'" class="redButtonTwo" @click="MaterialSave">保存至草稿箱</button> -->
          <!-- <button v-else @click="saveDraft" class="redButtonTwo">保存</button> -->
          <!-- <button class="cancelButtonTwo"  @click="allReturn">返回</button> -->
          <!-- <button class="cancelButtonTwo"  @click="submit">提交</button> -->
        </div>
      </div>
    </div>
    <contentPreview :object="postModel" :contentId="previewContentId" v-model="coverShow" :allNewKind="fromType"></contentPreview>
    <userPicker :title="'发送测试消息'" v-on:choosedConfirm="confirUserPicker($event)" v-model="userPickerModel" :pickerModel="'allRelease'"></userPicker>
    <!--内容列表-新建内容-->
    <model v-if="showMaterial" :buttonType="0" :title="'新建草稿'" :minWidth="'500px'" v-on:on-cancel="cancelModel()" v-on:on-confirm="confirModel()">
      <div class="t_c" style="margin-top: 30px;margin-bottom: 20px;height: 200px">
        <span><i class="colorRed m_r_5">*</i><abbr>内容类别：</abbr></span>
        <abbr style="width: 150px" class="d_i">
          <allSelect :chooseData="allcontent2" :needReturn="'id'" :placeholder="'请选择内容分类'" :matchValue="'typeName'" :showValue="'{{typeName}}'" v-model="addnewContentType">
          </allSelect>
        </abbr>
      </div>
    </model>
  </div>
</template>

<script>
import '../../../../static/utf8-jsp/ueditor.config'
import '../../../../static/utf8-jsp/ueditor.all'
import '../../../../static/utf8-jsp/lang/zh-cn/zh-cn'
import '../../../../static/utf8-jsp/ueditor.parse.js'
import { VueCropper } from 'vue-cropper'
import contentPreview from '../../myComponents/contentPreview'
let scorllData = []
let setIntervalImg
export default {
  name: 'editContList',
  data () {
    return {
      showClop: false,
      bindScorllImg: [
        {
          imgUrl: '',
          imgId: 0,
          url: ''
        }
      ],
      example2: {
        // img的路径自行修改
        img: '',
        info: true,
        size: 0.5,
        outputType: 'jpeg',
        canScale: true,
        autoCrop: true,
        centerBox: true,
        // 只有自动截图开启 宽度高度才生效
        autoCropWidth: 800,
        autoCropHeight: 344,
        fixed: true,
        // 真实的输出宽高
        infoTrue: true,
        fixedNumber: [100, 43]
      },
      showScorllFlag: false,
      userInfo: JSON.parse(window.sessionStorage.getItem('userInfo')),
      addnewContentType: '',
      showMaterial: false,
      ue: '',
      ueEn: '',
      previewContentId: parseInt(this.$route.query.id),
      coverShow: false,
      token: window.sessionStorage.getItem('token'),
      baseUrl: process.env.config.baseUrl,
      CNmode: true,
      fromType: this.$route.query.fromType,
      selectContentName: this.$route.query.selectContentName,
      showModel: false,
      tabSwitch: 1,
      totalPage: 1,
      page: 1,
      postModel: {
        ContentTypeId: parseInt(this.$route.query.selectContentType),
        Id: parseInt(this.$route.query.id),
        TitleCN: '',
        CoverCN: 0,
        SummaryCN: '',
        ContentCN: '',
        TitleEN: '',
        CoverEN: 0,
        SummaryEN: '',
        ContentEN: '',
        CreateTime: '',
        materialScope: ''
      },
      chooseUserList: [],
      userPickerModel: false,
      newNumId: '',
      allcontent2: JSON.parse(window.localStorage.getItem('canEditList')),
      postData: {
        pageIndex: 1,
        pageSize: this.$commonJs.commonPageSize
      }
    }
  },
  created () {
    console.log(this.postModel.Id)
    console.log(this.postModel.Id !== 0)
    if (this.postModel.Id !== 0) {
      this.getDetail()
    }
    // if (this.fromType === 'MaterialLibrary') {
    //   this.getconTypeList(1)
    // }
  },
  mounted () {
    setTimeout(p => {
      // eslint-disable-next-line no-undef
      this.ue = UE.getEditor('ueditor', {
        BaseUrl: '',
        UEDITOR_HOME_URL: 'static/utf8-jsp/',
        toolbars: [
          ['fullscreen', 'source', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontborder', 'fontfamily', 'fontsize', 'paragraph','customstyle', '|', 'imagenone','imageleft','imageright','imagecenter',],
          ['indent','directionalityltr','directionalityrtl','rowspacingtop','rowspacingbottom','lineheight','justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|','strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'pasteplain', '|', 'forecolor', 'touppercase', 'tolowercase', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', 'link','unlink', 'simpleupload', 'insertvideo']
        ]
      })
      // 'blockquote',
      // eslint-disable-next-line no-undef
      this.ueEn = UE.getEditor('ueditor2', {
        BaseUrl: '',
        UEDITOR_HOME_URL: 'static/utf8-jsp/',
        toolbars: [
          ['fullscreen', 'source', 'undo', 'redo', '|', 'bold', 'italic', 'underline', 'fontborder', 'fontfamily', 'fontsize', 'paragraph','customstyle', '|', 'imagenone','imageleft','imageright','imagecenter',],
          ['indent','directionalityltr','directionalityrtl','rowspacingtop','rowspacingbottom','lineheight','justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|','strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'autotypeset', 'pasteplain', '|', 'forecolor', 'touppercase', 'tolowercase', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', 'link','unlink', 'simpleupload', 'insertvideo']
        ]
      })
      if (this.postModel.Id === 0) {
        setTimeout(p => {
          let dom = document.createElement('div')
          dom.id = 'addScorllButton'
          let html = '<div title="轮播图上传"><i class="icon iconfont iconlunbo"></i></div>'
          dom.innerHTML = html
          let dom2 = document.createElement('div')
          dom2.id = 'addScorllButton2'
          dom2.innerHTML = html
          console.log(document.querySelectorAll('.edui-toolbar'))
          document.querySelectorAll('.edui-toolbar')[1].appendChild(dom)
          document.querySelectorAll('.edui-toolbar')[3].appendChild(dom2)
          document.getElementById('addScorllButton').onclick = p => {
            this.showScorllFlag = true
            this.bindScorllImg = [
              {
                imgUrl: '',
                imgId: 0,
                url: ''
              }
            ]
          }
          document.getElementById('addScorllButton2').onclick = p => {
            this.showScorllFlag = true
            this.bindScorllImg = [
              {
                imgUrl: '',
                imgId: 0,
                url: ''
              }
            ]
          }
        }, 2000)
      }
    }, 10)
  },
  destroyed () {
    const domList = document.querySelectorAll('.showUEplace')
    for (let i = 0; i < domList.length; i++) {
      domList[i].style.display = 'none'
    }
    this.ue.destroy()
    this.ueEn.destroy()
  },
  methods: {
    preview () {
    },
    submit () {
    },
    dataURLtoBlob (dataurl) {
      let arr = dataurl.split(',')
      let mime = arr[0].match(/:(.*?);/)[1]
      let bstr = atob(arr[1])
      let n = bstr.length
      let u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    blobToFile (theBlob, fileName) {
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    clopConfirm () {
      this.$refs.cropper2.getCropData((data) => {
        this.modelSrc = data
        this.model = false
        this.example2.img = this.modelSrc
        // console.log(this.example2.img)
        var blob = this.dataURLtoBlob(this.modelSrc)
        var file = this.blobToFile(blob, '裁剪后图片')
        console.log(file.size)
        if (file.size > 2048000) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '提示',
            content: '文件大小不允许大于2M',
            stayTime: 5
          })
          return
        }
        this.signalUpload(file)
      })
    },
    clopuploadImg (e, num) {
      // 上传图片
      this.example2.img = ''
      var file = e.target.files[0]
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '提示',
          content: '图片类型必须是.gif,jpeg,jpg,png,bmp中的一种',
          stayTime: 5
        })
        // alert('图片类型必须是.gif,jpeg,jpg,png,bmp中的一种')
        return false
      }
      this.showClop = true
      this.$nextTick(p => {
        var reader = new FileReader()
        reader.onload = (e) => {
          let data
          data = e.target.result
          if (typeof e.target.result === 'object') {
            // 把Array Buffer转化为blob 如果是base64不需要
            data = window.URL.createObjectURL(new Blob([e.target.result]))
          } else {
            data = e.target.result
          }
          if (num === 1) {
            this.option.img = data
          } else if (num === 2) {
            this.example2.img = data
          }
        }
        reader.readAsArrayBuffer(file)
      })
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blobcs
    },
    reduceBanner (index) {
      this.bindScorllImg.splice(index, 1)
    },
    addnewBanner () {
      let data = {
        imgUrl: '',
        imgId: 0,
        url: ''
      }
      this.bindScorllImg.push(data)
    },
    async changeImgFile (e, index) {
      let fileImg = e.target.files[0]
      this.bindScorllImg[index].imgId = await this.$commonJs.uploadFile(fileImg)
      this.bindScorllImg[index].imgUrl = this.baseUrl + '/api/Article/file/' + this.bindScorllImg[index].imgId
      // this.allspeakerRequestList.avatar = baseUrl.baseUrl + '/api/Assistant/DownloadFile?fileId=' + this.avatarId
      e.target.value = ''
    },
    confirmAddScorll () {
      for (let i = 0; i < this.bindScorllImg.length; i++) {
        if (this.bindScorllImg[i].imgUrl === '') {
          this.$commonJs.alertTips({
            type: 'error',
            title: '错误',
            content: '有图片没上传,请检查！',
            stayTime: 5
          })
          return
        }
        if (this.bindScorllImg[i].url && this.bindScorllImg[i].url !== '' && this.bindScorllImg[i].url.indexOf('http') !== 0) {
          this.$commonJs.alertTips({
            type: 'error',
            title: '错误',
            content: '图片链接必须以http或者https开头',
            stayTime: 5
          })
          return
        }
      }
      let html = '<section class="myScorllImgPlace">'
      html += '<section class="dotPlace">'
      for (let i = 0; i < this.bindScorllImg.length; i++) {
        if (i === 0) {
          html += '<b class="dot active"></b>'
        } else {
          html += '<b class="dot"></b>'
        }
      }
      html += '</section>'
      html += '<section style="left: 0px" class="showPlace">'
      for (let i = 0; i < this.bindScorllImg.length; i++) {
        html += '<section>'
        if (this.bindScorllImg[i].url !== '') {
          html += '<a target="_blank" href="' + this.bindScorllImg[i].url + '">'
        } else {
          html += '<a>'
        }
        html += '<img src="' + this.bindScorllImg[i].imgUrl + '" alt="">'
        html += '</a>'
        html += '</section>'
      }
      html += '</section>'
      html += '</section>'
      if (this.CNmode) {
        // this.ue.body.innerHTML = this.ue.body.innerHTML + html
        this.ue.focus()
        this.ue.execCommand('inserthtml', html)
      } else {
        // this.ueEn.body.innerHTML = this.ueEn.body.innerHTML + html
        this.ueEn.focus()
        this.ueEn.execCommand('inserthtml', html)
      }
      this.showScorllFlag = false
    },
    // getconTypeList (pageIndex) {
    //   this.postData.pageIndex = pageIndex
    //   let url = this.$commonJs.returnQuery('/api/contentType/all', {pageIndex: 1, pageSize: 99999})
    //   this.$axiox.get(url).then(msg => {
    //     this.allcontent2 = JSON.parse(JSON.stringify(msg.result.items))
    //   })
    // },
    // getconTypeList () {
    //   this.$axiox.get('/api/contentType/fromuser/' + JSON.parse(this.userInfo.id)).then(msg => {
    //     let editorTypes = JSON.parse(JSON.stringify(msg.result.editorTypes))
    //     let ownerTypes = JSON.parse(JSON.stringify(msg.result.ownerTypes))
    //     this.allcontent2 = this.$commonJs.distinct(editorTypes, ownerTypes)
    //   })
    // },
    getDetail () {
      let url = ''
      if (this.fromType === 'MaterialLibrary') {
        url = '/api/content/material?materialId=' + this.previewContentId
      } else {
        url = '/api/Article/Add/' + this.postModel.Id
      }
      this.$axiox.get(url).then(p => {
        this.postModel = {
          ContentTypeId: parseInt(p.result.contentTypeId),
          Id: parseInt(p.result.id),
          TitleCN: p.result.titleCN,
          CoverCN: p.result.coverCN,
          SummaryCN: p.result.summaryCN,
          ContentCN: p.result.contentCN,
          TitleEN: p.result.titleEN,
          CoverEN: p.result.coverEN,
          SummaryEN: p.result.summaryEN,
          ContentEN: p.result.contentEN,
          materialScope: p.result.materialScope,
          CreateTime: p.result.CreateTime,
          LastModifyTime: p.result.LastModifyTime,
          tag: p.result.tag
        }
        let time = setInterval(p => {
          if (this.ue.body && this.ueEn.body) {
            this.ue.body.innerHTML = this.postModel.ContentCN
            this.ueEn.body.innerHTML = this.postModel.ContentEN
            let dom = document.createElement('div')
            dom.id = 'addScorllButton'
            let html = '<div title="轮播图上传"><i class="icon iconfont iconlunbo"></i></div>'
            dom.innerHTML = html
            let dom2 = document.createElement('div')
            dom2.id = 'addScorllButton2'
            dom2.innerHTML = html
            console.log(document.querySelectorAll('.edui-toolbar'))
            document.querySelectorAll('.edui-toolbar')[1].appendChild(dom)
            document.querySelectorAll('.edui-toolbar')[3].appendChild(dom2)
            document.getElementById('addScorllButton').onclick = p => {
              this.showScorllFlag = true
              this.bindScorllImg = [
                {
                  imgUrl: '',
                  imgId: 0,
                  url: ''
                }
              ]
            }
            document.getElementById('addScorllButton2').onclick = p => {
              this.showScorllFlag = true
              this.bindScorllImg = [
                {
                  imgUrl: '',
                  imgId: 0,
                  url: ''
                }
              ]
            }
            ScorllImg()
            clearInterval(time)
          }
        }, 100)
        console.log(this.postModel)
      })
    },
    async signalUpload (e) {
      // let fileImg = e.target.files[0]
      let fileImg = e
      if (fileImg.type.indexOf('image') >= 0) {
        this.postModel.CoverCN = await this.$commonJs.uploadFile(fileImg)
        this.postModel.CoverEN = this.postModel.CoverCN
        // this.allspeakerRequestList.avatar = baseUrl.baseUrl + '/api/Assistant/DownloadFile?fileId=' + this.avatarId
        // e.target.value = ''
        document.getElementById('inFile').value = ''
        this.showClop = false
      } else {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '只允许上传图片',
          stayTime: 5
        })
      }
    },
    changeType (type) {
      this.CNmode = type
    },
    MaterialSave () {
      this.showMaterial = true
      this.addnewContentType = ''
    },
    confirModel () {
      if (this.addnewContentType === '') {
        this.$commonJs.alertTips({
          type: 'error',
          title: '错误',
          content: '请选择内容类别',
          stayTime: 5
        })
        return
      }
      this.postModel.ContentCN = this.ue.getContent()
      this.postModel.ContentEN = this.ueEn.getContent()
      let data = JSON.parse(JSON.stringify(this.postModel))
      data.ContentTypeId = this.addnewContentType
      data.Id = 0
      if ((this.postModel.ContentCN !== '' && this.postModel.TitleCN === '') || (this.postModel.ContentCN === '' && this.postModel.TitleCN !== '')) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请确保标题和内容的完整性',
          stayTime: 5
        })
        return
      }
      if ((this.postModel.ContentEN !== '' && this.postModel.TitleEN === '') || (this.postModel.ContentEN === '' && this.postModel.TitleEN !== '')) {
        this.$commonJs.alertTips({
          type: 'error',
          title: '失败',
          content: '请确保标题和内容的完整性',
          stayTime: 5
        })
        return
      }
      this.$axiox.post('/api/Article/Add', data).then(p => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '保存成功',
          stayTime: 5
        })
        this.showMaterial = false
        this.$router.go(-1)
      })
    },
    cancelModel () {
      this.showModel = false
      this.showMaterial = false
      this.showScorllFlag = false
      this.showClop = false
      document.getElementById('inFile').value = ''
    },
    // 返回上一页
    allReturn () {
      this.$commonJs.doubleComfirm({
        content: '确定要跳转吗？如果您有未保存的内容，可能会丢失哦。',
        successFun: msg => {
          this.$router.go(-1)
        },
        errorFun: msg => {
        }
      })
    },
    getTime () {
      let date1 = new Date()
      let year = date1.getFullYear()
      let month = date1.getMonth() + 1
      let day = date1.getDate()
      return year + '-' + month + '-' + day
    },
    saveDraft () {
      this.postModel.ContentCN = this.ue.getContent()
      this.postModel.CreateTime = this.getTime()
      this.postModel.LastModifyTime = this.getTime()
      this.postModel.ContentEN = this.ueEn.getContent()
      let data = {
        id: 0,
        title: this.postModel.TitleCN,
        summary: this.postModel.SummaryCN,
        content: this.postModel.ContentCN,
        wxContent: '',
        tags: '',
        status: 0,
        categoryId: 0,
        categoryName: this.$route.query.selectContentName || '',
        picUrl: 'string',
        createId: 0,
        createTime: this.postModel.LastModifyTime,
        lastModifyTime: this.postModel.LastModifyTime,
        lastModifyId: 0,
        lasfModifyName: 'string',
        fileID: 0
      }
      console.log(this.postModel)
      if (parseInt(this.postModel.Id) === 0) {
        this.$axiox.post('/api/Article/Add', data).then(p => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '保存成功',
            stayTime: 5
          })
          this.previewContentId = p.result
          this.postModel.Id = p.result
          this.$router.go(-1)
        })
      } else {
        // data.id = this.postModel.Id
        this.$axiox.post('/api/Article/update', data).then(p => {
          this.$commonJs.alertTips({
            type: 'success',
            title: '成功',
            content: '保存成功',
            stayTime: 5
          })
          let reFlashId = this.previewContentId
          this.previewContentId = 0
          setTimeout(p => {
            this.previewContentId = reFlashId
            setTimeout(p => {
              ScorllImg()
            }, 3000)
          }, 10)
          // this.previewContentId = p.result
          this.$router.go(-1)
        })
      }
    },
    addMaterial () {
    },
    SendList () {
      this.userPickerModel = true
    },
    confirUserPicker (e) {
      let emailList = []
      for (let i = 0; i < e.chooseUserList.length; i++) {
        emailList.push(e.chooseUserList[i].email)
      }
      this.$axiox.put('/api/Article/Add/push?contentIds=' + this.previewContentId, emailList).then(msg => {
        this.$commonJs.alertTips({
          type: 'success',
          title: '成功',
          content: '发送成功!',
          stayTime: 5
        })
      })
    }
  },
  components: {
    // 'Editor': Editor,
    'contentPreview': contentPreview,
    'vueCropper': VueCropper
  }
}
function ScorllImg () {
  clearInterval(setIntervalImg)
  scorllData = []
  let imgDomList = document.querySelectorAll('.myScorllImgPlace')
  for (let i = 0; i < imgDomList.length; i++) {
    scorllData.push(0)
  }
  setIntervalImg = setInterval(P => {
    for (let i = 0; i < scorllData.length; i++) {
      if (imgDomList[i]) {
        scorllData[i]++
        let dotList = imgDomList[i].querySelectorAll('.dot')
        for (let j = 0; j < dotList.length; j++) {
          dotList[j].classList.remove('active')
        }
        if (scorllData[i] > imgDomList[i].querySelectorAll('.showPlace img').length - 1) {
          scorllData[i] = 0
        }
        if (imgDomList[i].querySelector('.showPlace')) {
          imgDomList[i].querySelector('.showPlace').style.left = (-100 * scorllData[i] + '%')
          dotList[scorllData[i]].classList.add('active')
        }
      }
    }
  }, 3000)
}
</script>

<style scoped>
  #editContList{
    margin-top: -65px;
  }
  .bottom{
     color:red;
     position: relative;
     bottom: -55px;
  }
  .t_r{
    margin-right: 360px;
  }
  #ueditor{
    min-height: 300px;
  }
  #ueditor2{
    min-height: 300px;
  }
  .input{
    width: 92%;
    margin-left: 8%;
  }

  .m_b_5{
    margin-left: -80px;
    margin-bottom: -20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/mainDateManager/editMainDateText.vue